import React, { Component } from 'react'
import isEmpty from 'lodash/isEmpty'
import styled from 'styled-components'
import { Modal, Row, Col, Form, Input, Button, Table } from 'antd'

import cloneDeep from 'lodash/cloneDeep'
import RowLayout from '../../RowLayout/RowLayout'
import LoadingModal from '../Loading'

const columns = (T, searchKeyword = '', replaceKeyword = '') => [
    {
        title: T('TITLE'),
        dataIndex: 'title',
        key: 'title'
    },
    {
        title: T('OLD_URL'),
        dataIndex: 'oldUrl',
        key: 'oldUrl',
        className: 'word-break',
        render: text => getHighlightedText(text, searchKeyword, '#d9f7be')
    },
    {
        title: T('NEW_URL'),
        dataIndex: 'newUrl',
        key: 'newUrl',
        className: 'word-break',
        render: text => getHighlightedText(text, replaceKeyword, '#bae7ff')
    }
]

const Container = styled.div`
    .image-wrapper {
        display: inline-block;
        padding: 20px;
        margin-top: 15px;
        border: 1px dashed #ccc;
        > img {
            max-width: 100%;
        }
    }
`

class LinkReviseModal extends Component {
    initialState = {
        links: [],
        foundMenuList: [],
        newMenuList: [],
        isChecked: false,
        searchKeyword: '',
        replaceKeyword: ''
    }

    state = this.initialState

    formRef = React.createRef()

    UNSAFE_componentWillReceiveProps(nextProps, prevState) {
        if (!prevState.isOpen && nextProps.isOpen) {
            let state = this.initialState
            this.setState(state)
        }
    }

    onSubmit() {
        this.formRef.current
            .validateFields()
            .then(values => {
                console.log(values)
                let { foundMenuList, newMenuList } = findAndReplace(
                    this.props.menuList,
                    values.searchKeyword,
                    values.replaceKeyword
                )

                this.setState({
                    foundMenuList,
                    newMenuList,
                    searchKeyword: values.searchKeyword,
                    replaceKeyword: values.replaceKeyword,
                    isChecked: true
                })
            })
            .catch(info => {
                console.log('Validate Failed:', info)
            })
    }

    onApply() {
        let { onSubmit } = this.props
        onSubmit && onSubmit(this.state.newMenuList)
    }

    render() {
        let { T, isOpen, onClose } = this.props

        let foundCount = this.state.foundMenuList.length

        return (
            <Modal
                title={T('REPLACE_URL')}
                width={720}
                centered
                destroyOnClose
                visible={isOpen}
                okText={T('APPLY')}
                okButtonProps={{ disabled: foundCount == 0 }}
                cancelText={T('CANCEL')}
                onOk={this.onApply.bind(this)}
                onCancel={() => onClose()}>
                <Container>
                    <Form ref={this.formRef} name="control-ref">
                        <RowLayout title={T('SEARCH')} contentSpan={14}>
                            <Form.Item
                                style={{ marginBottom: 0 }}
                                name="searchKeyword"
                                rules={[
                                    {
                                        required: true,
                                        message: T('FORM_ERR_REQUIRE')
                                    }
                                ]}>
                                <Input />
                            </Form.Item>
                        </RowLayout>
                        <RowLayout title={T('REPLACE_WITH')} contentSpan={14}>
                            <Row gutter={16}>
                                <Col flex="auto">
                                    <Form.Item
                                        style={{ marginBottom: 0 }}
                                        name="replaceKeyword">
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col flex="100px">
                                    <Button
                                        type="primary"
                                        block
                                        onClick={this.onSubmit.bind(this)}>
                                        {T('CHECK')}
                                    </Button>
                                </Col>
                            </Row>
                        </RowLayout>
                    </Form>

                    {this.state.isChecked && (
                        <Table
                            title={() => (
                                <b
                                    style={{
                                        color:
                                            foundCount > 0
                                                ? '#52c41a'
                                                : '#cf1322'
                                    }}>
                                    {T('FOUND_ITEMS', {
                                        count: foundCount
                                    })}
                                </b>
                            )}
                            size="small"
                            style={{ marginTop: 24 }}
                            columns={columns(
                                T,
                                this.state.searchKeyword,
                                this.state.replaceKeyword
                            )}
                            dataSource={this.state.foundMenuList}
                        />
                    )}
                </Container>

                <LoadingModal isOpen={this.state.isLoading} />
            </Modal>
        )
    }
}

const findAndReplace = (
    menuList = [],
    searchKeyword = '',
    replaceKeyword = ''
) => {
    let foundMenuList = []
    let newMenuList = cloneDeep(menuList)
    menuList.forEach((menuLevel1, index1) => {
        if (menuLevel1.url.includes(searchKeyword)) {
            let newUrl = menuLevel1.url.replace(searchKeyword, replaceKeyword)
            newMenuList[index1].url = newUrl
            foundMenuList.push({
                title: menuLevel1.title,
                oldUrl: menuLevel1.url,
                newUrl
            })
        }

        if (menuLevel1.submenus && menuLevel1.submenus.length > 0) {
            menuLevel1.submenus.forEach((menuLevel2, index2) => {
                if (menuLevel2.url.includes(searchKeyword)) {
                    let newUrl = menuLevel2.url.replace(
                        searchKeyword,
                        replaceKeyword
                    )
                    newMenuList[index1].submenus[index2].url = newUrl
                    foundMenuList.push({
                        title: menuLevel2.title,
                        oldUrl: menuLevel2.url,
                        newUrl
                    })
                }

                if (menuLevel2.submenus && menuLevel2.submenus.length > 0) {
                    menuLevel2.submenus.forEach((menuLevel3, index3) => {
                        if (menuLevel3.url.includes(searchKeyword)) {
                            let newUrl = menuLevel3.url.replace(
                                searchKeyword,
                                replaceKeyword
                            )
                            newMenuList[index1].submenus[index2].submenus[
                                index3
                            ].url = newUrl
                            foundMenuList.push({
                                title: menuLevel3.title,
                                oldUrl: menuLevel3.url,
                                newUrl
                            })
                        }
                    })
                }
            })
        }
    })

    return { foundMenuList, newMenuList }
}

const getHighlightedText = (text, highlight, color) => {
    const parts = text.split(new RegExp(`(${highlight})`, 'gi'))
    return (
        <span>
            {' '}
            {parts.map((part, index) => (
                <span
                    key={index}
                    style={
                        part == highlight
                            ? { fontWeight: 'bold', backgroundColor: color }
                            : {}
                    }>
                    {part}
                </span>
            ))}{' '}
        </span>
    )
}

export default LinkReviseModal
